// Copyright (c) 2025 WiseTime. All rights reserved.

import { Action } from "redux"
import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import * as Slice from "../slice"
import * as Actions from "../actions"
import { executor, Init, userTeamService } from "../../../app/rpc"
import { GetTeamRequestSchema, GetTeamResponse } from "../../../generated/wt/svc/customer/user_team_pb"

type GetTeamRpc = (request: Init<typeof GetTeamRequestSchema>) => Observable<GetTeamResponse>

export const getTeam = (getTeamRpc: GetTeamRpc) => (action$: Observable<Action>): Observable<Action> =>
  action$.pipe(
    filter(Slice.setCurrentSiteId.match),
    mergeMap(({ payload: { siteId }}) =>
      getTeamRpc({ teamId: siteId })
        .pipe(
          map(r => r.team),
          map(Slice.setTeamProto),
          catchError(_ => of(Actions.getTeamFailed()))
        )
    )
  )

const getTeamRpc = (request: Init<typeof GetTeamRequestSchema>): Observable<GetTeamResponse> =>
  executor(() => userTeamService.getTeam(create(GetTeamRequestSchema, request)))

export default getTeam(getTeamRpc)
